import React from "react";

interface SectionTitleProps {
  children: React.ReactNode;
  className?: string;
}

export const SectionTitle: React.FC<SectionTitleProps> = ({
  children,
  className = "",
}) => {
  return (
    <h2
      className={`mb-1 line-clamp-1 min-h-[24px] text-[18px] font-medium text-[#1a1a1a] sm:text-[20px] ${className}`}
    >
      {children}
    </h2>
  );
};
